// extracted by mini-css-extract-plugin
export default {"finish":"PetitionStats_finish__1eLvD","finish_true":"PetitionStats_finish_true__3EiWj","finish_false":"PetitionStats_finish_false__61UvT","head":"PetitionStats_head__Jyztq"};